import { Feature, isTrueBundleFeature } from '../../../../models';

/**
 * The noun a quantity is counted in: "licenses" for the seat-based SKUs, "sessions" for
 * TestCloud, "package" for a True Bundle (sold as one fixed package) and "seats" for the legacy
 * True bundles. Shared by the order summary, Order History and Payment Status so a component
 * never reads "3 sessions" on one screen and "3 licenses" on another.
 */
export const getSummaryUnitWord = (
  feature: Feature,
  quantity: number,
) => {
  // A True Bundle is sold as one package, never as seats.
  if (isTrueBundleFeature(feature)) {
    return quantity === 1 ? 'package' : 'packages';
  }

  if (
    feature === Feature.PER_USER_KSE
    || feature === Feature.UNLIMITED_ENGINE
    || feature === Feature.TESTOPS_G3
  ) {
    return quantity === 1 ? 'license' : 'licenses';
  }

  if (
    feature === Feature.TESTCLOUD_SESSION_CROSS_BROWSER
    || feature === Feature.TESTCLOUD_SESSION_MOBILE_APP
    || feature === Feature.TESTCLOUD_SESSION_PRIVATE_DEVICE
    || feature === Feature.TESTCLOUD_SESSION_WEB_DESKTOP
    || feature === Feature.TESTCLOUD_SESSION_LIVE_TESTING
  ) {
    return quantity === 1 ? 'session' : 'sessions';
  }

  return quantity === 1 ? 'seat' : 'seats';
};

export const getSummaryQuantityLabel = (
  feature: Feature,
  quantity: number,
) => `${quantity} ${getSummaryUnitWord(feature, quantity)}`;
